export const duration = 0.6;
export const entryDelay = 0.2;
export const imageFadeDuration = 800;
